import { render } from "./WebAppIcons.vue?vue&type=template&id=f22bee76&scoped=true"
import script from "./WebAppIcons.vue?vue&type=script&lang=js"
export * from "./WebAppIcons.vue?vue&type=script&lang=js"

import "./WebAppIcons.vue?vue&type=style&index=0&id=f22bee76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22bee76"]])

export default __exports__